module.exports = kolibriCoreAppGlobal.themeConfig;